const initializeFaq = (root) => {
  if (!root) {
    return;
  }

  const tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-faq-panel]'));

  const closePanelAccordions = (panel) => {
    if (!panel) {
      return;
    }

    const questionButtons = panel.querySelectorAll('[data-faq-question]');

    questionButtons.forEach((button) => {
      const answerId = button.getAttribute('aria-controls');
      const answer = answerId ? panel.querySelector(`#${CSS.escape(answerId)}`) : null;
      const icon = button.querySelector('.home-faq__icon');

      button.setAttribute('aria-expanded', 'false');

      if (answer) {
        answer.hidden = true;
      }

      if (icon) {
        icon.textContent = '+';
      }
    });
  };

  const activateTab = (targetTab) => {
    if (!targetTab) {
      return;
    }

    const targetPanelId = targetTab.getAttribute('aria-controls');

    tabs.forEach((tab) => {
      const isCurrent = tab === targetTab;
      tab.classList.toggle('is-active', isCurrent);
      tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      tab.setAttribute('tabindex', isCurrent ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isCurrent = panel.id === targetPanelId;
      panel.classList.toggle('is-active', isCurrent);
      panel.hidden = !isCurrent;

      if (!isCurrent) {
        closePanelAccordions(panel);
      }
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });
  });

  const questionButtons = root.querySelectorAll('[data-faq-question]');

  questionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const answerId = button.getAttribute('aria-controls');
      const answer = answerId ? root.querySelector(`#${CSS.escape(answerId)}`) : null;

      if (!answer) {
        return;
      }

      const icon = button.querySelector('.home-faq__icon');
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;

      button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      answer.hidden = !nextExpanded;

      if (icon) {
        icon.textContent = nextExpanded ? '−' : '+';
      }
    });
  });
};

const bootstrapFaq = () => {
  const faqSections = document.querySelectorAll('.home-faq');

  if (!faqSections.length) {
    return;
  }

  faqSections.forEach((faqSection) => {
    initializeFaq(faqSection);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapFaq);
} else {
  bootstrapFaq();
}
